import { Link } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";
import { motion } from "motion/react";

export default function CapsHero({ hero }) {
  return (
    <section className="relative isolate min-h-[580px] overflow-hidden rounded-[2rem] bg-neutral-950 text-white sm:min-h-[650px] lg:min-h-[720px]">
      <motion.img
        initial={{ scale: 1.07 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        src={hero.image}
        alt="Captex premium caps editorial campaign"
        className="absolute inset-0 size-full object-cover object-center opacity-75"
      />

      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/10" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/10" />

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute -right-20 top-10 size-72 rounded-full bg-red-600/15 blur-3xl"
      />

      <div className="relative flex min-h-[580px] items-end p-6 sm:min-h-[650px] sm:p-10 lg:min-h-[720px] lg:items-center lg:p-16 xl:p-20">
        <motion.div
          initial={{ opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.12 }}
          className="max-w-4xl"
        >
          <p className="text-xs font-black uppercase tracking-[0.34em] text-white/55">
            {hero.eyebrow}
          </p>

          <h1 className="mt-5 max-w-5xl text-5xl font-black uppercase leading-[0.86] tracking-[-0.07em] sm:text-7xl md:text-8xl lg:text-[7.5rem] xl:text-[9rem]">
            {hero.title}
          </h1>

          <p className="mt-7 max-w-2xl text-lg font-semibold leading-7 text-white/90 sm:text-xl">
            {hero.subtitle}
          </p>

          <p className="mt-4 max-w-xl text-sm leading-7 text-white/60 sm:text-base">
            {hero.description}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              href={hero.primaryAction.href}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-black uppercase text-black transition hover:-translate-y-0.5 hover:bg-neutral-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black"
            >
              {hero.primaryAction.label}
              <ArrowRight className="size-4" />
            </Link>

            <Link
              href={hero.secondaryAction.href}
              className="inline-flex min-h-12 items-center justify-center rounded-full border border-white/35 bg-white/10 px-6 py-3 text-sm font-black uppercase text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
            >
              {hero.secondaryAction.label}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}